import { VenueEditFormValues } from '../../types';
import { OpeningHoursText } from './constants';

const transferNumberToDoubleDigitString = (number: number) => {
  return number.toString().padStart(2, '0');
};

export const getDisplayOperatingHours = (
  operatingHoursInfo: VenueEditFormValues['operatingHours'][0]
): string | string[] => {
  const { status, times } = operatingHoursInfo;

  if (status !== 'open') {
    const statusText = OpeningHoursText[status];
    return statusText;
  }

  const openingHours = times.map(({ startTime, endTime }) => {
    if (typeof startTime !== 'number' || typeof endTime !== 'number') {
      return '無效的設定值';
    }

    const startTimeString = transferNumberToDoubleDigitString(startTime);
    const endTimeString = transferNumberToDoubleDigitString(endTime);

    return `${startTimeString}:00 - ${endTimeString}:00`;
  });

  return openingHours;
};
